import React, { useRef, useContext, useEffect, useState } from 'react'
import CookieConsent from 'react-cookie-consent'
import Button from 'components/ui-elements/button'
import { Wrap, Content, Buttons, ButtonClose } from './index.styled'
import { LayoutContext } from 'styles/layout-provider'
import { COOKIES_DELAY_MS } from 'styles/splash-timing'
import { useLocation } from '@reach/router'

const CookiesBanner = () => {
  const ref = useRef()
  const refCookie = useRef()
  const { showSplash } = useContext(LayoutContext)
  const [isShow, setIsShow] = useState(true)
  const location = useLocation()

  useEffect(() => {
    if (!isShow) return
    const delay = showSplash && location.pathname === '/' ? COOKIES_DELAY_MS : 2000
    if (showSplash && location.pathname === '/') {
      ref?.current?.classList?.remove('show')
    }
    const timeout = setTimeout(() => {
      ref?.current?.classList?.add('show')
    }, delay)
    return () => clearTimeout(timeout)
  }, [showSplash, location.pathname, isShow])

  const onClose = () => {
    ref?.current?.classList?.remove('show')
    setIsShow(false)
  }

  return (
    <Wrap ref={ref}>
      <CookieConsent
        ref={refCookie}
        location='none'
        buttonText='ok'
        disableStyles
        containerClasses='cookies-banner'
        buttonClasses='cookies-banner-accept-btn'
        disableButtonStyles
        buttonWrapperClasses='cookies-banner-btns'
        contentClasses='cookies-banner-content'
        expires={150}
      >
        <Content>
          This website uses cookies to ensure you get the best experience on our website.
          <Buttons>
            <Button
              className='accept'
              as='button'
              type='button'
              onClick={() => refCookie.current?.accept()}
              $width='120'
              $widthMobile='120'
            >
              ACCEPT
            </Button>
            <Button
              href='https://www.cookiesandyou.com'
              target='_blank'
              as='a'
              $width='120'
              $widthMobile='120'
            >
              Learn more
            </Button>
          </Buttons>
        </Content>
        <ButtonClose onClick={onClose} />
      </CookieConsent>
    </Wrap>
  )
}
export default CookiesBanner
